import { createSelector } from 'reselect';

import { dashboardSelector } from 'modules/dashboard/store/selectors/dashboard';

export const addressesSelector = createSelector(dashboardSelector, (state) => state.addresses);
